
const state = {
  mensagem: '',
  tipo: ''
}

const getters = {
  getMensagem: state => {
    return state.mensagem
  },
  getTipo: state => {
    return state.tipo
  }
}

const mutations = {
  setMensagem (state, data) {
    state.mensagem = data
  },
  setTipo (state, data) {
    state.tipo = data
  }
}

const actions = {
  setMensagemQuestionario (context, mensagem, tipo) {
    context.commit('setMensagem', mensagem)
    context.commit('setTipo', tipo)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/mensagem.js